module.exports = __webpack_public_path__ + "242ebc0155b73ed4da41bab1126742e0.jpg";